import PrevNext from './PrevNext.vue'

/*
 * Must have variable "steps" and "pageerrors"
 */

const steps = {
  data () {
    return {
      step: 1,
    };
  },
  components: {PrevNext},
  computed: {
    pagevalid () {
      if (this.pageerrors) {
        return this.pageerrors.map(errs => (errs.length === 0));
      } else {
        return [];
      }
    },
    allvalid () {
      return (this.pagevalid.filter(p=>p).length === this.pagevalid.length);
    },
  },
  methods: {
    goto (want) {
      //if: skip step or invalid step
      if (want < 1 || want > this.steps.length) {
        return;
      }
      //find first after-valid step
      var firstInvalid = false;
      for (let i = 1; i <= this.steps.length; i++) {
        if (!this.pagevalid[i-1]) {
          firstInvalid = i;
          break;
        }
      }
      if (firstInvalid) {
        want = Math.min(want, firstInvalid);
      }
      //if wanted step is inactive
      if (!this.steps[want-1]) {
        if (want < this.step) {
          //go to back to previous active step
          for (let i = want; i >= 1; i--) {
            if (this.steps[i-i]) {
              return this.step = i;
            }
          }
        } else {
          //go to forward to next active step
          for (let i = want; i <= this.steps.length; i++) {
            if (this.steps[i-i]) {
              return this.step = i;
            }
          }
        }
      } else {
        return this.step = want;
      }
    },
    /*generateFields(data) {
      var def = {
        required: true,
        type: 'text',
        value: '',
        touched: false,
      };
      return data.map((inpage, page) => {
        for (let name in inpage) {
          inpage[name] = Object.assign({}, def, inpage[name]);
          //inpage[name].error = this.errors[page][name] || false;
        }
        return inpage;
      });
    },*/
    /*setValueForEmpty(name, value) {
      if (!value) {
        return;
      }
      for (let p in this.fields) {
        //only if value is empty
        if (Object.keys(this.fields[p]).includes(name) && !this.fields[p][name].value) {
          this.fields[p][name].value = value;
        }
      }
    },*/
  },
};

export default steps;


// WEBPACK FOOTER //
// ./src/helpers/mixins/steps/index.js